import { css } from '@emotion/react';
import type { BeautifulMentionsMenuProps } from 'lexical-beautiful-mentions';
import { theme } from '@frontend/theme';

// Moving this from message-composer to a separate component

export const MentionMenu = ({ loading, children, ...props }: BeautifulMentionsMenuProps) => {
  return (
    <ul className='mention-menu-style' css={mentionMenuStyle} {...props}>
      {children}
    </ul>
  );
};

const mentionMenuStyle = css`
  background: ${theme.colors.white};
  border-radius: ${theme.borderRadius.large};
  box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0;
  min-width: 100px;
  width: 400px;
  max-height: 300px;
  overflow: auto;
  padding: ${theme.spacing(2)};
  z-index: ${theme.zIndex.popover};
  border: 1px solid ${theme.colors.neutral10};
  position: absolute;
  bottom: calc(
    100% + 32px
  ); //TODO: there seems to be no good way to pass in positional props to the menu, so using CSS here
  :focus {
    outline: none;
  }
`;
